{
    "Address": "Anschrift",
    "Bank Account": "Bankkonto",
    "CofC Number": "DIHT Nummer",
    "P.O. Box 9663": "Postbus 9663",
    "The Netherlands": "The Netherlands",
    "VAT Number": "MwSt Nummer"
}
